/// <reference path="../typings.d.ts" />
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './shared/title';
import { Account, validateToken } from './services/account.service';
import { IdentityService } from './services/identity.service';
import { Alert } from './shared/alert';
import { Config } from './config';
import { AppService } from './services/app.service';

@Component({
	selector: 'login',
	template:
		`<div class="col-lg-3 col-md-6 col-xs-12">
      <alert [alert]="msg"></alert>
   </div>`
})

export class LoginComponent implements OnInit, OnDestroy {
	public msg: Alert;

	constructor(
		private router: Router,
		private title: AppTitle,
		private account: Account,
		private dvc: IdentityService,
		private config: Config,
		private app: AppService,
	) {
		this.msg = new Alert();
		title.setTitles({ title: 'Login', dashboard: 'Login' });
		title.setBreadcrumbs([
			{ title: 'Login', link: '' }
		]);
	}

	ngOnInit() {
		let gotopage = this.config.goToPage();

		if (validateToken()) {

			this.dvc.loadUser().subscribe(ur => {

				let usr = this.dvc.userRoles();
				let us = this.account.getUser();
				if (usr == null && us == null) {
					this.msg.error('You don\'t have access to this page.');
					// in case user login and token has being stored into localStorage but since this user is not allowed to view this page
					// and there is no logout link, we need to remove token and other kyes from localStorage for security reasons
					this.account.removeLocalStorage();
					return;
				}

				// trigger app component to reload some of the ui parts
				this.app.onLoadApp.emit(null);
				if (!gotopage || gotopage === '/') {
					this.router.navigateByUrl(`/idp/${ur.acctNumber}/idps`);
				} else {
					this.router.navigateByUrl(gotopage);
				}

			}, err => {
				if (err.message == 'unauthorized') {
					this.msg.error('You don\'t have access to this page.');
				} else {
					this.msg.error('There is an error when processing this request, please try again.');
				}
			});
		} else {
			this.msg.error('Invalid token, please logout and login again.');
		}
	}

	ngOnDestroy() {
		this.config.removeLocalStorage();
	}
}
